module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAABHNCSVQICAgIfAhkiAAAAPxJREFUOI2tlNGNxCAMRB/0sArdQGdJKoPr5iSK4D5i2OwujrPSzReyx5MB23EoqIEEJBpRQgnHLufy+KXM6txUqLECqRfj+AEQ8XN814S72FYXWl3I4tDitRrYrkka4ZuaGkiWmOb4JPrM14VcF5oqdi+fAfzo5rODGoqaOWpTDaRh2RAz0Z/Mm19nvFM2NAuN6GmsY8403OFI3t9xNxzYSF4cRIOortpAI+LYvVhNF0T7uuIOTleeDe6INeJp+Ge8TY7lCJwG811w7OzFJvX9/yycFNQgA6tgunpviakLQ2xec+u3xLhRnvH+/Qf7IfgizOjySu/gIa7O5R9Ksq7rSy3JewAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/training/img(23).png
// module id = V/i7
// module chunks = 1